import { Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import BannerInquiry from "./BannerInquiry";

import ModalPop from "./ModalPop";

import { useRef } from "react";

const Banner = () => {
  const bannerLsit = [
    {
      bg: "/images/banner1.webp",
      txt: "/images/bannerT1.webp",
    },
    {
      bg: "/images/banner2.webp",
      txt: "/images/bannerT2.webp",
    },
    {
      bg: "/images/banner3.webp",
      txt: "/images/bannerT3.webp",
    },
  ];

  const popupRef = useRef<HTMLDivElement>(null);

  const openfunc = () => {
    popupRef.current!.style.display = "block";
  };

  const closefunc = () => {
    popupRef.current!.style.display = "none";
  };
  return (
    <div className=" relative w-full h-full min-h-[500px] md:min-h-[700px] lg:max-h-[760px] 2xl:min-h-screen 3xl:min-h-full 3xl:max-h-[950px]">
      <ModalPop popupRef={popupRef} closefnc={closefunc} />
      <div className=" relative w-full h-full grid grid-rows-2 xl:grid-rows-1 xl:grid-cols-2 bg-primary">
        <Swiper
          slidesPerView={1}
          autoplay={{
            delay: 4000,
            disableOnInteraction: false,
            stopOnLastSlide: false,
          }}
          loop={true}
          loopAdditionalSlides={2}
          modules={[Autoplay]}
          className="mySwipe relative w-full h-full  max-h-[650px] min-h-[500px] md:min-h-[700px] lg:max-h-[760px] 2xl:min-h-screen 3xl:min-h-full 3xl:max-h-[950px]"
        >
          {bannerLsit.map((v, i) => (
            <SwiperSlide key={`banner-${i}`} className=" relative w-full h-full">
              <div
                onClick={openfunc}
                className=" absolute left-0 top-0 w-full h-full grid items-center justify-items-center pl-[calc((100%-var(--container))/2)] z-10"
              >
                <img src={v.txt} alt={`비우고 채우고 이벤트 배너 ${i + 1}`} className="!relative w-full h-auto object-contain max-h-[450px]" />
              </div>
              <img src={v.bg} alt={`비우고 채우고 유품정리·특수청소 안내 ${i + 1}`} className="!relative w-full h-full object-cover object-center" />
            </SwiperSlide>
          ))}
        </Swiper>
        <div className=" grid items-center px-3 lg:pl-16 lg:pr-[calc((100%-var(--container))/2)] translate-y-10">
          <div className=" relative w-fit h-fit">
            <div className=" relative w-full h-fit max-w-[650px] pb-4">
              <img src="/images/bannerIcon.webp" alt="비우고 채우고 상담 아이콘" className="absolute bottom-0 right-0 w-auto h-32" />
              <img
                alt="비우고 채우고 로고"
                className="!relative w-auto h-full max-h-8 lg:max-h-12"
                src="/images/bannerLogo.webp"
                width={581}
                height={232}
              />
            </div>
            <div className=" relative w-full h-fit max-w-[650px]">
              <BannerInquiry />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banner;
